export function getLocaleFromBrowser() {
	if (navigator && navigator.language) {
		return navigator.language;
	}
}
